import Vue from 'vue'
import Notificactions from 'vue-notification'

Vue.use(Notificactions);